/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';

var CaretDownIcon = createIcon({
  name: 'CaretDownIcon',
  height: 512,
  width: 320,
  svgPath: 'M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z',
  yOffset: '',
  xOffset: '',
  transform: ''
});

export default CaretDownIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-icons/dist/esm/icons/caret-down-icon.js
// module id = 110
// module chunks = 0